import React from 'react';

const PageNotFound = () => {
    return ( <div>
        <div className='centered'>Page Not Found ://</div>
        </div> );
}
 
export default PageNotFound;